export class UploadGpkdObject {
    maSoThueStatus: string = '';
    signatureStatus: string = '';

    constructor(obj = null) {
        obj = obj || {};
        this.maSoThueStatus = obj.maSoThueStatus || '';
        this.signatureStatus = obj.signatureStatus || '';
    }
}